import { useEffect } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { t, Trans } from '@lingui/macro'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'

import TextInputController from '@/components/ui/inputs/TextInputController'
import PhoneNumberInputController from '@/components/ui/inputs/PhoneNumberInputController'

import { useIsSA } from '@/hooks/useIsSA'

import { ParentFormData, useParentForm } from '../model/useParentForm'

export type ParentDialogProps = {
  data: ParentFormData
  onClose?: () => void
  onSubmit: SubmitHandler<ParentFormData>
  open: boolean
  readOnly?: boolean
}

export function ParentDialog(props: ParentDialogProps) {
  const { data, onClose, open, onSubmit, readOnly = false } = props
  const isSA = useIsSA()
  const { rhForm } = useParentForm({ initialValues: data })
  const { reset } = rhForm

  useEffect(() => {
    if (!open) {
      reset()
    }
  }, [open, reset])

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{isSA ? <Trans>Emergency contact information</Trans> : <Trans>Parent information</Trans>}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextInputController control={rhForm.control} fullWidth label={t`Last name`} name={`lastname`} readOnly={readOnly} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInputController control={rhForm.control} fullWidth label={t`First name`} name={`firstname`} readOnly={readOnly} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInputController control={rhForm.control} fullWidth label={t`Email`} name={`email`} readOnly={readOnly} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <PhoneNumberInputController control={rhForm.control} label={isSA ? t`Contact Number` : t`Phone`} name={`phone`} readOnly={readOnly} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInputController control={rhForm.control} fullWidth label={t`City`} name={`city`} readOnly={readOnly} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInputController control={rhForm.control} fullWidth label={t`Postal code`} name={`cp`} readOnly={readOnly} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="neutral">
          <Trans>Close</Trans>
        </Button>
        {!readOnly && (
          <Button onClick={rhForm.handleSubmit(onSubmit)} variant="contained">
            <Trans>Submit</Trans>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ParentDialog
